// extracted by mini-css-extract-plugin
export default {"cls1":"VeloStepperLabel-Label_cls1__VZgMx","cls2":"VeloStepperLabel-Label_cls2__DFl5J VeloStepperLabel-Label_cls1__VZgMx"};